import { ListingSkeleton } from "./ListingSkeleton/ListingSkeleton";

export const ListingGridSkeletons = (props) => {
    return [...Array(props.listings)].map((x,i) => { 
        return <ListingSkeleton key={i} /> 
    })
}